// Umschalter zwischen den eigenen Sammlungen, ueber den Reitern der
// Statistik.
//
// Er aendert NUR die Ansicht, nicht die aktive Sammlung: wer hier
// nachsieht, wie die gemeinsame Sammlung steht, will nicht, dass sein
// naechster Fund auf der Sammelseite stillschweigend dort landet. Umgestellt
// wird weiter in den Einstellungen.
//
// Eine Liste statt eines Schalters mit zwei Seiten, weil es mehr als eine
// gemeinsame Sammlung geben kann.

import type { Sammlung } from "../lib/me.js";

export function SammlungsWahl({
  sammlungen,
  gewaehlteId,
  onWaehlen,
}: {
  sammlungen: Sammlung[];
  gewaehlteId: number | undefined;
  onWaehlen: (id: number) => void;
}) {
  if (sammlungen.length < 2) return null;
  return (
    <label className="mb-2 flex items-center gap-3 rounded bg-flaeche-inhalt px-4 py-3 shadow-sm">
      <span className="shrink-0 text-sm text-neutral-500">Sammlung</span>
      <select
        value={gewaehlteId ?? ""}
        onChange={(e) => onWaehlen(Number(e.target.value))}
        className="min-w-0 flex-1 bg-transparent text-right text-base outline-none"
      >
        {sammlungen.map((s) => (
          <option key={s.id} value={s.id}>
            {s.kind === "personal" ? `${s.name} (eigene)` : s.name}
          </option>
        ))}
      </select>
    </label>
  );
}
